import React, { useState } from 'react'
import { useAsync } from 'react-use'
import {
  Col,
  DatePicker,
  Form,
  Modal as ModalAntd,
  notification,
  Radio,
  Row,
  Space,
  Tooltip,
  Typography,
} from 'antd'
import { DeleteOutlined, SettingOutlined } from '@ant-design/icons'

import Button from 'components/Button'
import Card from 'components/Card'
import Modal from 'components/Modal'
import Select from 'components/Select'
import Table from 'components/Table'
import TextArea from 'components/TextArea'
import Upload from 'components/Upload'

import moment from 'moment'

import Styled from './styled'

import _ from 'lodash'

import { useTranslate } from 'hooks/translate'

import { getAllUser } from 'services/user'
import { getValueListApi, getValueListByTypeCodeApi } from 'services/value_list'
import { createTaskApi, deleteTaskApi, getTaskApi, updateTaskApi } from 'services/reportTask'
import {
  deleteReportAttachmentApi,
  getReportAttachmentApi,
  postReportAttachmentApi,
} from 'services/ReportAttachment'

export default function RequestInformation ({ report_header_id, disabled }) {
  const { t } = useTranslate()

  const [form] = Form.useForm()
  const [isLoading, setLoading] = useState(false)
  const [dataSource, setDataSource] = useState([])

  const [rhId, setRhId] = useState(report_header_id)
  const [rqId, setRqId] = useState(null)
  const [editingId, setEditingId] = useState(null)
  const [showModal, setShowModal] = useState(false)

  const [allUser, setAllUser] = useState([])
  const [priorityOptions, setPriorityOptions] = useState([])
  const [statusOptions, setStatusOptions] = useState([])

  const [fileList, setFileList] = useState([])
  const is_riskAnalyst = JSON.parse(localStorage.getItem('user'))?.profile?.role_id === 4

  const getFile = async (report_task_id) => {
    setFileList([])
    const filesRes = await getReportAttachmentApi({
      report_header_id,
      report_task_id,
      report_attribute_value_id: null,
    })

    const tempData = []

    filesRes?.data.map((item) => {
      tempData.push({
        uid: item?.report_attachment_id,
        name: item?.file_path.substring(item?.file_path.lastIndexOf('/') + 1),
        status: 'done',
        url: `${process.env.REACT_APP_SERVICE_URL}${item.file_path}`,
      })
    })

    setFileList(tempData)

    return tempData
  }

  const getAllUserList = async () => {
    const res = await getAllUser()

    if (res.status === 'error') {
      notification.error({
        message: t('Failed'),
        description: res.message,
      })

      return
    }

    setAllUser(
      _.map(res.data, (item) => {
        return { label: item?.employee.employee_name_th, value: item?.user_id }
      })
    )
  }

  const getPriorityList = async () => {
    const res = await getValueListByTypeCodeApi('TKP')

    if (res.status === 'error') {
      notification.error({
        message: t('Failed'),
        description: res.message,
      })

      return
    }

    const priorityList = await getValueListApi(res?.data?.value_list_type_id)
    setPriorityOptions(
      _.sortBy(
        _.map(priorityList?.data, (item) => {
          return { label: item?.name, value: item?.id }
        }),
        'value'
      )
    )
  }

  const getStatusList = async () => {
    const res = await getValueListByTypeCodeApi('TKS')

    if (res.status === 'error') {
      notification.error({
        message: t('Failed'),
        description: res.message,
      })

      return
    }

    const statusList = await getValueListApi(res?.data?.value_list_type_id)
    setStatusOptions(
      _.map(statusList?.data, (item) => {
        return { label: item?.name, value: item?.id }
      })
    )
  }

  const getQuestionList = async () => {
    if (isLoading) return

    setLoading(true)

    const typeId = await getValueListByTypeCodeApi('TKT')
    const rqId = await getValueListApi(typeId?.value_list_type_id)
      .then((list) => _.find(list.data, (data) => data.name === 'Request Information'))
      .then((data) => data.id)

    // console.log('rhId', rhId)
    //get task from report_task_id
    const res = await getTaskApi({ incident_id: rhId })
    const tempData = []
    if (res.data.length) {
      for (let i = 0; i < res.data.length; i++) {
        if (res.data[i].task_type_id === rqId) {
          tempData.push(res.data[i])
        }
      }
    }

    setRqId(rqId)
    setDataSource(tempData)
    setLoading(false)
  }

  const createQuestion = async (values) => {
    const res = await createTaskApi({
      report_header_id: rhId,
      task_name: values?.question,
      task_description: values?.description,
      task_assignee_id: values?.assignee,
      task_start_date: values?.startDate.format('YYYY-MM-DD'),
      task_due_date: values?.dueDate.format('YYYY-MM-DD'),
      task_type_id: rqId,
      task_status_id: values?.status,
      task_priority_id: values?.priority,
      task_result: values?.result,
    })

    if (res.status === 'error') {
      notification.error({
        message: t('Failed'),
        description: res.message,
      })
      return
    } else {
      if (values.files != null) {
        uploadFiles(values.files, report_header_id, res?.data?.report_task_id, null)
      }
      notification.success({
        message: t('Created Success'),
        description: res.message,
      })
    }

    getQuestionList()

    setShowModal(false)
    form.resetFields()
  }

  const updateQuestion = async (editingId, values) => {
    const res = await updateTaskApi(editingId, {
      report_header_id: rhId,
      task_name: values?.question,
      task_description: values?.description,
      task_assignee_id: values?.assignee,
      task_start_date: values?.startDate.format('YYYY-MM-DD'),
      task_due_date: values?.dueDate.format('YYYY-MM-DD'),
      task_type_id: rqId,
      task_status_id: values?.status,
      task_priority_id: values?.priority,
      task_result: values?.result,
    })

    if (res.status === 'error') {
      notification.error({
        message: t('Failed'),
        description: res.message,
      })
      return
    } else {
      if (values.files != null) {
        uploadFiles(values.files, report_header_id, editingId, null)
      }
      notification.success({
        message: t('Updated Success'),
        description: res.message,
      })
    }

    getQuestionList()

    setShowModal(false)
    form.resetFields()
  }

  const deleteQuestion = async (id) => {
    const res = await deleteTaskApi(id)

    if (res.status === 'error') {
      notification.error({
        message: t('Failed'),
        description: res.message,
      })

      return
    } else {
      deleteFileNotUse([])
      notification.success({
        message: t('Deleted Success'),
        description: res.message,
      })
    }

    getQuestionList()
  }

  const uploadFiles = async (
    files,
    report_header_id,
    report_task_id,
    report_attribute_value_id
  ) => {
    const uploadFile = []
    const oldFile = []

    files.map((item) => {
      if (item?.status === 'done') {
        oldFile.push(item.uid)
      } else {
        uploadFile.push(item.originFileObj)
      }
    })

    if (oldFile.length > 0) deleteFileNotUse(oldFile)

    if (files.length === 0) deleteFileNotUse([])

    if (uploadFile.length > 0) {
      const res = await postReportAttachmentApi(uploadFile, {
        report_header_id: report_header_id,
        report_task_id: report_task_id,
        report_attribute_value_id: report_attribute_value_id,
      })

      if (res.status === 'error') {
        notification.error({
          message: t('Failed'),
          description: res.message,
        })
        return
      }
    }
  }

  const deleteFileNotUse = async (noDelIds) => {
    const delIds = []
    _.map(fileList, (item) => {
      if (noDelIds.includes(item.uid)) {
      } else {
        delIds.push(item.uid)
      }
    })

    if (delIds.length > 0) {
      const res = await deleteReportAttachmentApi(delIds)

      if (res.status === 'error') {
        notification.error({
          message: t('Failed'),
          description: res.message,
        })

        return
      }
    }
  }

  useAsync(async () => {
    getQuestionList()
    getAllUserList()
    getPriorityList()
    getStatusList()
  }, [])

  const columns = [
    {
      title: t('Question'),
      dataIndex: 'task_name',
      key: 'task_name',
      className: 'bold',
      width: '20%',
      render: (text) => {
        return <Typography.Text style={{ wordBreak: 'break-all' }}>{text}</Typography.Text>
      },
    },
    {
      title: t('Description'),
      dataIndex: 'description',
      key: 'description',
      width: '20%',
      render: (text) => {
        return <Typography.Text style={{ wordBreak: 'break-all' }}>{text}</Typography.Text>
      },
    },
    {
      title: t('Assignee'),
      dataIndex: 'assignee_name',
      key: 'assignee_name',
      width: '20%',
    },
    {
      title: t('Priority'),
      dataIndex: 'priority',
      key: 'priority',
    },
    {
      title: t('Due Date'),
      dataIndex: 'dueDate',
      key: 'dueDate',
      width: '12%',
    },
    {
      title: t('Status'),
      dataIndex: 'status',
      key: 'status',
    },
    {
      title: t('Actions'),
      dataIndex: 'actions',
      key: 'actions',
      width: '5%',
      render: (text, record) => {
        return (
          <Space size='small'>
            <Tooltip title={t('Edit')}>
              <Button
                type='link'
                icon={<SettingOutlined />}
                onClick={async () => {
                  // console.log('record', record)
                  setEditingId(record?.id)

                  const files = await getFile(record?.id, record)

                  form.setFieldsValue({
                    question: record?.task_name,
                    description: record?.description,
                    assignee: record?.assignee_id,
                    startDate: moment(record?.startDate),
                    dueDate: moment(record?.dueDate),
                    priority: record?.task_priority,
                    status: record?.task_status_id,
                    result: record?.result,
                    files: files,
                  })

                  setShowModal(true)
                }}
              />
            </Tooltip>
            <Tooltip title={t('Delete')}>
              <Button
                type='link'
                danger
                icon={<DeleteOutlined />}
                onClick={() => {
                  ModalAntd.confirm({
                    title: t('Confirm deletion'),
                    icon: null,
                    maskClosable: true,
                    closeIcon: true,
                    content: (
                      <div>
                        <dl>
                          <dt>{t('Name')}</dt>
                          <dd>- {record.task_name}</dd>
                          <dt>{t('Assignee')}</dt>
                          <dd>- {record.assignee_name}</dd>
                        </dl>
                      </div>
                    ),
                    okButtonProps: {
                      shape: 'round',
                    },
                    okText: t('Delete'),
                    okType: 'primary',
                    cancelButtonProps: {
                      shape: 'round',
                    },
                    cancelText: t('Cancel'),
                    onOk: async () => {
                      await deleteQuestion(record?.id)
                    },
                  })
                }}
                disabled={disabled}
              />
            </Tooltip>
          </Space>
        )
      },
    },
  ]

  return (
    <Styled className='request-information-component'>
      <Space size='middle' direction='vertical' style={{ width: '100%' }}>
        <Card
          title={t('Request Information')}
          titleExtra={
            <Space>
              <Button
                type='primary'
                onClick={async () => {
                  setShowModal(true)

                  form.setFieldsValue({
                    startDate: moment(),
                  })
                }}
                disabled={disabled}
                style={{ width: 80 }}
              >
                {t('Add')}
              </Button>
            </Space>
          }
        >
          <Table
            loading={isLoading}
            columns={columns}
            dataSource={dataSource}
            pagination={false}
            scroll={{ x: 1100 }}
          />
        </Card>
      </Space>
      <Modal
        width={600}
        visible={showModal}
        title={editingId ? t('Edit Question') : t('Create New Question')}
        onCancel={() => {
          setShowModal(false)
        }}
        afterClose={() => {
          if (editingId) {
            form.resetFields()
          }
          setEditingId(null)
        }}
        footer={[
          <Button
            key='create'
            type='primary'
            onClick={() => {
              form.submit()
            }}
            disabled={is_riskAnalyst ? false : disabled}
          >
            {editingId ? t('Update') : t('Create')}
          </Button>,
        ]}
      >
        <Form
          form={form}
          layout='vertical'
          onFinish={async (values) => {
            if (editingId) {
              updateQuestion(editingId, values)
            } else {
              createQuestion(values)
            }
          }}
        >
          <Row gutter={8}>
            <Col span={24}>
              <Form.Item
                label={t('Question')}
                name='question'
                rules={[
                  {
                    required: true,
                    message: t('Please input question'),
                  },
                ]}
              >
                <TextArea disabled={disabled} />
              </Form.Item>
            </Col>
            <Col span={24}>
              <Form.Item label={t('Description')} name='description'>
                <TextArea disabled={disabled} />
              </Form.Item>
            </Col>
            <Col span={24}>
              <Form.Item
                label={t('Assignee')}
                name='assignee'
                rules={[
                  {
                    required: true,
                    message: t('Please select assignee'),
                  },
                ]}
              >
                <Select
                  placeholder={t('Select Assignee')}
                  options={allUser}
                  disabled={is_riskAnalyst ? false : disabled}
                />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                label={t('Start Date')}
                name='startDate'
                rules={[
                  {
                    required: true,
                    message: t('Please select date'),
                  },
                ]}
              >
                <DatePicker
                  style={{ width: '100%', borderRadius: '10px' }}
                  disabled={disabled}
                  disabledDate={(current) => {
                    return moment().add(-1, 'days') >= current
                  }}
                />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                label={t('Due Date')}
                name='dueDate'
                rules={[
                  {
                    required: true,
                    message: t('Please select date'),
                  },
                ]}
              >
                <DatePicker
                  style={{ width: '100%', borderRadius: '10px' }}
                  disabled={disabled}
                  disabledDate={(current) => {
                    return moment().add(-1, 'days') >= current
                  }}
                />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                label={t('Priority')}
                name='priority'
                rules={[
                  {
                    required: true,
                    message: t('Please select priority'),
                  },
                ]}
              >
                <Radio.Group
                  options={priorityOptions}
                  optionType='button'
                  buttonStyle='solid'
                  disabled={disabled}
                />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                label={t('Status')}
                name='status'
                rules={[
                  {
                    required: true,
                    message: t('Please select status'),
                  },
                ]}
              >
                <Select
                  placeholder={t('Select Status')}
                  options={statusOptions}
                  disabled={disabled}
                />
              </Form.Item>
            </Col>
            <Col span={24}>
              <Form.Item label={t('Result')} name='result'>
                <TextArea disabled={disabled} />
              </Form.Item>
            </Col>
            <Col span={24}>
              <Form.Item label={t('Attach File')} name='files'>
                <Upload disabled={disabled} />
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Modal>
    </Styled>
  )
}
